import ClosingCta from '@/components/home/ClosingCta';
import Hero from '@/components/home/Hero';
import HowItWorks from '@/components/home/HowItWorks';
import ImpactCounters from '@/components/home/ImpactCounters';
import NetworkDiagram from '@/components/home/NetworkDiagram';
import GrainOverlay from '@/components/design-system/GrainOverlay';
import Nav from '@/components/layout/Nav';
import { PageLayout } from '@/components/poof-ui';
import React from 'react';

export const HomePage: React.FC = () => {
  return (
    <>
      <GrainOverlay />
      <Nav />
      <PageLayout fullBleed>
        <div className='pb-20 md:pb-0'>
          <Hero />
          <HowItWorks />
          <ImpactCounters />
          <NetworkDiagram />
          <ClosingCta />
        </div>
      </PageLayout>
    </>
  );
};

export default HomePage;
